import React from 'react';
import {
    Document,
    Page,
    View,
    Image,
    StyleSheet,
    PDFViewer,
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
        padding: 30,
        flexDirection: 'column',
    },
    logoBox: {
        width: 200,
        height: 70,
        border: '1pt solid #ccc',
        justifyContent: 'center',
        alignItems: 'center',
    },
    logo: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
});

const TestLogoPdf: React.FC = () => {
    const baseUrl =
        typeof window !== 'undefined'
            ? window.location.origin
            : 'https://hailhelper.app'; // Replace with your production domain if needed

    const logoUrl = `${baseUrl}/img/crop-west-logo.png`;

    return (
        <PDFViewer width="100%" height="600">
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.logoBox}>
                        <Image src={logoUrl} style={styles.logo} />
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    );
};

export default TestLogoPdf;
